import { useEffect, useState } from "react";
import { Button, Card, Col, Modal, Row } from "react-bootstrap";
import { AvField, AvForm } from "availity-reactstrap-validation";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import NotificationService from "../../../../services/NotificationService";
import { Translate } from "../../../Enums/Tranlate";
import Select from "react-select";
import ZoneService from "../../../../services/ZoneService";
import UserService from "../../../../services/UserService";

const AddNotification = () => {
	const [formData, setFormData] = useState({
		title_en: "",
		title_ar: "",
		description_en: "",
		description_ar: "",
		selectType: { label: "Generally Notifications", value: "generally" },
		type: "",
	});
	const [options, setOptions] = useState([]);
	const [loading, setLoading] = useState(false);
	const navigate = useNavigate();
	const notificationService = new NotificationService();
	const Service =
		formData?.selectType?.value === "zone"
			? new ZoneService()
			: new UserService();
	const lang = useSelector((state) => state.auth.lang);
	const typesOptions = [
		{ label: "Generally Notifications", value: "" },
		{ label: "Zone Notifications", value: "zone" },
		{ label: "User Notifications", value: "client" },
	];

	useEffect(() => {
		if (
			formData?.selectType?.value === "zone" ||
			formData?.selectType?.value === "client"
		) {
			Service.getList().then((res) => {
				if (res?.status) {
					let response = res?.data?.data?.data;
					let data = response?.map((val) => {
						return {
							label:
								formData?.selectType?.value === "zone"
									? val?.name_en
									: val?.client_name,
							value: val?.id,
						};
					});
					setOptions(data);
				}
			});
		}
	}, [formData?.selectType]);

	const submit = () => {
		if (
			(formData?.selectType?.value === "client" ||
				formData?.selectType?.value === "zone") &&
			!formData?.type?.value
		) {
			toast.error(`Select ${formData?.selectType?.value} First`);
			return;
		}
		if (!formData?.description_en || !formData?.description_ar) {
			toast.error("Enter Message First");
			return;
		}
		let data = {
			title_en: formData?.title_en,
			title_ar: formData?.title_ar,
			description_en: formData?.description_en,
			description_ar: formData?.description_ar,
		};
		if (formData?.selectType?.value === "zone")
			data["zone_id"] = formData?.type?.value;
		if (formData?.selectType?.value === "client")
			data["client_id"] = formData?.type?.value;

		let type = formData?.selectType?.value || "";
		setLoading(true);
		notificationService
			.create(type, data)
			?.then((res) => {
				if (res?.status === 201) {
					toast.success("Notification Added Successfully");
					navigate("/notification");
				}
				setLoading(false);
			})
			.catch(() => setLoading(false));
	};

	return (
		<Card>
			<AvForm className="form-horizontal" onValidSubmit={submit}>
				<Card.Body>
					<Row>
						<Col md={6} className="mb-3">
							<label className="text-label">{Translate[lang]?.type}</label>
							<Select
								value={formData?.selectType}
								name="selectType"
								placeholder={Translate[lang]?.select}
								options={typesOptions}
								onChange={(e) =>
									setFormData({
										...formData,
										selectType: e,
									})
								}
							/>
						</Col>
						<Col md={6}>
							{(formData?.selectType?.value === "zone" ||
								formData?.selectType?.value === "client") && (
								<>
									<label className="text-label">
										{formData?.selectType?.value === "zone"
											? Translate[lang]?.zone
											: Translate[lang]?.client}
									</label>
									<Select
										value={formData?.type}
										name="type"
										placeholder={Translate[lang]?.select}
										options={options}
										onChange={(e) =>
											setFormData({
												...formData,
												type: e,
											})
										}
									/>
								</>
							)}
						</Col>
						<Col md={6}>
							<AvField
								label={Translate[lang].english_title}
								type="text"
								placeholder={Translate[lang].english_title}
								bsSize="lg"
								name="title_en"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								value={formData.title_en}
								onChange={(e) =>
									setFormData((prev) => ({ ...prev, title_en: e.target.value }))
								}
							/>
						</Col>

						<Col md={6}>
							<AvField
								label={Translate[lang].arabic_title}
								type="text"
								placeholder={Translate[lang].arabic_title}
								value={formData.title_ar}
								name="title_ar"
								validate={{
									required: {
										value: true,
										errorMessage: Translate[lang].field_required,
									},
								}}
								onChange={(e) =>
									setFormData((prev) => ({ ...prev, title_ar: e.target.value }))
								}
							/>
						</Col>
						<Col md={6}>
							<label className="d-block">
								{Translate[lang].english_description}
							</label>
							<textarea
								style={{
									border: "1px solid hsl(0, 0%, 80%)",
									padding: "6px 12px",
									width: "100%",
									borderRadius: "0.3rem",
									maxHeight: "200px",
									minHeight: "100px",
									height: " 200px",
								}}
								name="description_en"
								type="text"
								value={formData.description_en}
								required
								placeholder={Translate[lang].english_description}
								onChange={(e) =>
									setFormData((prev) => ({
										...prev,
										description_en: e.target.value,
									}))
								}
							/>
						</Col>
						<Col md={6}>
							<label className="d-block">
								{Translate[lang].arabic_description}
							</label>
							<textarea
								style={{
									border: "1px solid hsl(0, 0%, 80%)",
									padding: "6px 12px",
									width: "100%",
									borderRadius: "0.3rem",
									maxHeight: "200px",
									minHeight: "100px",
									height: " 200px",
								}}
								name="description_ar"
								type="text"
								value={formData.description_ar}
								required
								placeholder={Translate[lang].arabic_description}
								onChange={(e) =>
									setFormData((prev) => ({
										...prev,
										description_ar: e.target.value,
									}))
								}
							/>
						</Col>
					</Row>
				</Card.Body>
				<Modal.Footer className="justify-content-between">
					<Button
						onClick={() => navigate("/notification")}
						variant="danger light">
						{Translate[lang].cancel}
					</Button>
					<Button variant="primary" type="submit" disabled={loading}>
						{Translate[lang].send}
					</Button>
				</Modal.Footer>
			</AvForm>
		</Card>
	);
};

export default AddNotification;
